import { createContext, useContext, type ReactNode } from "react";
import type { AiApi } from "./types";
import { unavailableAiApi } from "./unavailableAiApi";

const Ctx = createContext<AiApi>(unavailableAiApi());
export const AiApiProvider = ({
  api,
  children,
}: {
  api: AiApi;
  children: ReactNode;
}) => <Ctx.Provider value={api}>{children}</Ctx.Provider>;
export const useAiApi = (): AiApi => useContext(Ctx);
